import * as React from "react";
import sendRequest from "../../helpers/ajax";
import IListResults from "../../types/IListResults";
import IMessageDetail from "../../types/IMessageDetail";
import IMessageDetailSearchRequest from "../../types/IMessageDetailSearchRequest";
import IResponse from "../../types/IResponse";
import MessageRecipientList from "./MessageRecipientList";

interface IMessageRecipientListContainerState {
    loading :boolean;
}

class MessageRecipientListContainer extends React.Component<{}, IMessageRecipientListContainerState>{

    constructor(props: {}) {
        super(props);

        this.state = {loading: false}

        this.search = this.search.bind(this);
    }

    public render(){
        return (
            <MessageRecipientList loading={this.state.loading} search={this.search} />
        );
    }

    private async search (request: IMessageDetailSearchRequest): Promise<IResponse<IListResults<IMessageDetail>> | null>{

        this.setState({loading: true});

        const response = await sendRequest<IResponse<IListResults<IMessageDetail>>>("/api/messages/searchmessagedetail", "POST", request);

        this.setState({loading: false});

        return response;
    }

}

export default MessageRecipientListContainer;



// WEBPACK FOOTER //
// ./src/components/MessageRecipientList/MessageRecipientListContainer.tsx